export const addressComponentNames = [
    "street_number",
    "route",  // Street name
    "locality", // City
    "postal_code",
    "administrative_area_level_1"  // State
];